// @flow

import { graphql, gql, compose } from 'react-apollo';

import ToolView from '../components/ToolView';

const TARGET_TOOL_QUERY = gql`
  query tool($slug: String!) {
    Tool(slug: $slug) {
      id
      name
      slug
      description
      detail
      features {
        id
        label
      }
      url
      isOpenSource
      sourceUrl
      createdAt
      updatedAt
      image {
        id
        url
      }
      categories {
        id
        label
        slug
      }
      counts {
        id
        value
        type
      }
    }
  }
`;

const ADD_FEATURE_MUTATION = gql`
  mutation addFeature($label: String!, $slug: String!) {
    createFeature(label: $label, slug: $slug) {
      id
      label
    }
  }
`;

const ADD_FEATURE_ON_TOOL_MUTATION = gql`
  mutation addFeatureOnTool($toolsToolId: ID!, $featuresFeatureId: ID!) {
    addToToolOnFeature(
      toolsToolId: $toolsToolId
      featuresFeatureId: $featuresFeatureId
    ) {
      toolsTool {
        id
        name
        features {
          id
          label
        }
      }
    }
  }
`;

// const UPDATE_TOOL_LIKE_MUTATION = gql`
//   mutation incrementLike($toolId: ID!) {
//     createCount(
//       type: LIKE,
//       value: 1,
//       toolId: $toolId,
//       usersIds: ["cj35p1r9v7zti0195ymkged0z"]
//     ) {
//       id
//       value
//       type
//     }
//   }
// `;

// updateOrCreateCount(
//       update: {
//         id: $countId,
//         type: LIKE,
//         value: 1,
//         toolId: $toolId,
//         usersIds: ["cj35p1r9v7zti0195ymkged0z"],
//       },
//       create: {
//         type: LIKE,
//         value: 1,
//         toolId: $toolId,
//         usersIds: ["cj35p1r9v7zti0195ymkged0z"],
//       }
//     ) {
//       id
//       value
//       type
//     }

export default compose(
  // graphql(UPDATE_TOOL_LIKE_MUTATION, { name: 'incrementLike' }),
  graphql(ADD_FEATURE_ON_TOOL_MUTATION, { name: 'addFeatureOnTool' }),
  graphql(ADD_FEATURE_MUTATION, { name: 'addFeature' }),
  graphql(TARGET_TOOL_QUERY, {
    options: ({ slug }) => ({
      variables: {
        slug,
      },
    }),
    name: 'toolData',
  })
)(ToolView);



// WEBPACK FOOTER //
// ./src/App/Tool/containers/ToolView.js